import { QueryClientHelper } from '#pplx/frontend/react-query/QueryClientHelper.js';
import { getUserOrganizationQueryKey } from '#pplx/frontend/user-info/orgInfoQueries.js';
export const getUserOrgDataKey = (...scope) => getUserOrganizationQueryKey(...scope);
// Ephemeral: the admin-only CrowdStrike Falcon object carries the CID and must
// never be persisted to IndexedDB with the rest of the query cache.
export const getCrowdStrikeFalconSettingsKey = (orgUuid) => QueryClientHelper.makeEphemeralQueryKey('/rest/enterprise/organization/{org_uuid}/crowdstrike-falcon', orgUuid);
export const getPremiumSecureEligibilityKey = (orgUuid) => QueryClientHelper.makeQueryKey('/rest/enterprise/organization/premium-secure-eligibility', orgUuid);
export const getPendingInvitationKey = () => QueryClientHelper.makeQueryKey('/rest/enterprise/user/pending-invitation');
const ORGANIZATION_USERS_QUERY_KEY = '/rest/enterprise/user/organization/users';
const ORG_SOURCE_PERMISSIONS_QUERY_KEY = '/rest/enterprise/user/organization/sources';
export const SUBJECT_SEARCH_QUERY_KEY = '/rest/enterprise/user/organization/subjects/search';
/**
 * @deprecated Use `getOrganizationMembersQueryKey` instead.
 */
export const getOrganizationUsersQueryKey = (query) => query
    ? QueryClientHelper.makeQueryKey(ORGANIZATION_USERS_QUERY_KEY, query)
    : QueryClientHelper.makeQueryKey(ORGANIZATION_USERS_QUERY_KEY);
// Uses the same prefix as deprecated getOrganizationUsersQueryKey so mutations invalidate both queries
export const getOrganizationMembersQueryKey = (params) => params
    ? QueryClientHelper.makeQueryKey(ORGANIZATION_USERS_QUERY_KEY, 'members', params)
    : QueryClientHelper.makeQueryKey(ORGANIZATION_USERS_QUERY_KEY, 'members');
export const getOrgSourcePermissionsKey = (params) => params
    ? QueryClientHelper.makeQueryKey(ORG_SOURCE_PERMISSIONS_QUERY_KEY, params)
    : QueryClientHelper.makeQueryKey(ORG_SOURCE_PERMISSIONS_QUERY_KEY);
export const getSubjectSearchKey = (params) => QueryClientHelper.makeQueryKey(SUBJECT_SEARCH_QUERY_KEY, params);
export const getSeatInfoQueryKey = () => QueryClientHelper.makeQueryKey('/rest/enterprise/user/organization/seat-info');
export const getJoinRequestsQueryKey = (params) => params?.filter
    ? QueryClientHelper.makeQueryKey('/rest/enterprise/organization/join-requests', params.filter)
    : QueryClientHelper.makeQueryKey('/rest/enterprise/organization/join-requests');
export const getUpgradeRequestsQueryKey = (params) => params?.filter
    ? QueryClientHelper.makeQueryKey('/rest/enterprise/organization/upgrade-requests', params.filter)
    : QueryClientHelper.makeQueryKey('/rest/enterprise/organization/upgrade-requests');
export const getMyJoinRequestQueryKey = () => QueryClientHelper.makeQueryKey('/rest/enterprise/organization/my-join-request');
const CONNECTOR_USAGE_QUERY_KEY = '/rest/connector-service/usage';
export const getConnectorUsageKey = (params) => params
    ? QueryClientHelper.makeQueryKey(CONNECTOR_USAGE_QUERY_KEY, params)
    : QueryClientHelper.makeQueryKey(CONNECTOR_USAGE_QUERY_KEY);
export const getUserConnectorUsageKey = (params) => params
    ? QueryClientHelper.makeQueryKey(CONNECTOR_USAGE_QUERY_KEY, 'user', params)
    : QueryClientHelper.makeQueryKey(CONNECTOR_USAGE_QUERY_KEY, 'user');
const COMPUTER_USAGE_QUERY_KEY = '/rest/insights/usage';
const ENTERPRISE_API_ORG_QUERY_KEY = '/rest/pplx-api/v2/enterprise-api-org';
// Ephemeral: API-key state must always reflect the server (another admin may
// have changed it), and key metadata should not persist to IndexedDB.
export const getEnterpriseApiOrgKey = () => QueryClientHelper.makeEphemeralQueryKey(ENTERPRISE_API_ORG_QUERY_KEY);
export const getEnterpriseAdminApiKeysKey = (apiOrgId) => QueryClientHelper.makeEphemeralQueryKey('/rest/pplx-api/v2/groups/{api_org_id}/api-keys/metadata', apiOrgId);
export const getComputerUsageKey = (params) => params
    ? QueryClientHelper.makeQueryKey(COMPUTER_USAGE_QUERY_KEY, params)
    : QueryClientHelper.makeQueryKey(COMPUTER_USAGE_QUERY_KEY);
const ANALYTICS_TABLE_QUERY_KEY = '/rest/insights/tables';
export const getAnalyticsTableKey = (params) => params
    ? QueryClientHelper.makeQueryKey(ANALYTICS_TABLE_QUERY_KEY, params)
    : QueryClientHelper.makeQueryKey(ANALYTICS_TABLE_QUERY_KEY);
const COMPUTER_USAGE_MEMBERS_QUERY_KEY = '/rest/insights/usage/members';
export const getComputerUsageMembersKey = (params) => params
    ? QueryClientHelper.makeQueryKey(COMPUTER_USAGE_MEMBERS_QUERY_KEY, params)
    : QueryClientHelper.makeQueryKey(COMPUTER_USAGE_MEMBERS_QUERY_KEY);
//# sourceMappingURL=enterpriseKeys.js.map